import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";

export default (editor: Editor, opts: RequiredPluginOptions) => {
  const { block, label, id } = opts;

  if (block) {
    editor.Blocks.add("blog-list", {
      media: `
<svg width="44" height="44" class="mx-auto" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M36.8333 7.33341H7.5C7.01377 7.33341 6.54745 7.52657 6.20364 7.87039C5.85982 8.2142 5.66667 8.68052 5.66667 9.16675V34.8334C5.66667 35.3196 5.85982 35.786 6.20364 36.1298C6.54745 36.4736 7.01377 36.6667 7.5 36.6667H36.8333C37.3196 36.6667 37.7859 36.4736 38.1297 36.1298C38.4735 35.786 38.6667 35.3196 38.6667 34.8334V9.16675C38.6667 8.68052 38.4735 8.2142 38.1297 7.87039C37.7859 7.52657 37.3196 7.33341 36.8333 7.33341ZM7.5 3.66675C6.04131 3.66675 4.64236 4.24621 3.61091 5.27766C2.57946 6.30911 2 7.70806 2 9.16675V34.8334C2 36.2921 2.57946 37.6911 3.61091 38.7225C4.64236 39.754 6.04131 40.3334 7.5 40.3334H36.8333C38.292 40.3334 39.691 39.754 40.7224 38.7225C41.7539 37.6911 42.3333 36.2921 42.3333 34.8334V9.16675C42.3333 7.70806 41.7539 6.30911 40.7224 5.27766C39.691 4.24621 38.292 3.66675 36.8333 3.66675H7.5Z" fill="currentColor"/>
<rect x="9" y="11" width="6" height="6" rx="1" fill="currentColor"/>
<path d="M10 19H14" stroke="currentColor" stroke-linecap="round"/>
<path d="M10 20.5H12.8571" stroke="currentColor" stroke-linecap="round"/>
<rect x="19" y="11" width="6" height="6" rx="1" fill="currentColor"/>
<path d="M20 19H24" stroke="currentColor" stroke-linecap="round"/>
<path d="M20 20.5H22.8571" stroke="currentColor" stroke-linecap="round"/>
<rect x="29" y="11" width="6" height="6" rx="1" fill="currentColor"/>
<path d="M30 19H34" stroke="currentColor" stroke-linecap="round"/>
<path d="M30 20.5H32.8571" stroke="currentColor" stroke-linecap="round"/>
<rect x="9" y="23" width="6" height="6" rx="1" fill="currentColor"/>
<path d="M10 31H14" stroke="currentColor" stroke-linecap="round"/>
<path d="M10 32.5H12.8571" stroke="currentColor" stroke-linecap="round"/>
<rect x="19" y="23" width="6" height="6" rx="1" fill="currentColor"/>
<path d="M20 31H24" stroke="currentColor" stroke-linecap="round"/>
<path d="M20 32.5H22.8571" stroke="currentColor" stroke-linecap="round"/>
<rect x="29" y="23" width="6" height="6" rx="1" fill="currentColor"/>
<path d="M30 31H34" stroke="currentColor" stroke-linecap="round"/>
<path d="M30 32.5H32.8571" stroke="currentColor" stroke-linecap="round"/>
</svg>
`,
      label,
      category: "common",
      select: true,
      content: { type: "blog-list" },
      ...block,
    });
  }
};
